import { render } from "./FaqsSection.vue?vue&type=template&id=c712d486&scoped=true"
import script from "./FaqsSection.vue?vue&type=script&lang=js"
export * from "./FaqsSection.vue?vue&type=script&lang=js"

import "./FaqsSection.vue?vue&type=style&index=0&id=c712d486&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c712d486"]])

export default __exports__